import React, { ReactNode, useState } from 'react';
import Footer from './Footer';
import LeftNavRail from './LeftNavRail';
import Header from './Header';

interface ILayoutProps {
  children: ReactNode;
  showFooter?: boolean;
  hideHeader?: boolean;
  hideLeftNav?: boolean;
  /** Passed to Header — see its `transparentOnDesktop`. */
  transparentHeader?: boolean;
}

const Layout: React.FC<ILayoutProps> = ({
  children,
  showFooter = true,
  hideHeader = false,
  hideLeftNav = false,
  transparentHeader = false,
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setMobileMenuOpen((prev) => !prev);
  const closeMobileMenu = () => setMobileMenuOpen(false);

  return (
    <div className="relative flex min-h-screen">
      {!hideLeftNav && (
        <div>
          <LeftNavRail
            mobileMenuOpen={mobileMenuOpen}
            onClose={closeMobileMenu}
          />
        </div>
      )}
      <div className="flex-1">
        {!hideHeader && (
          <Header
            onMenuToggle={toggleMobileMenu}
            transparentOnDesktop={transparentHeader}
          />
        )}
        <main
          className={`${hideHeader ? '' : 'pt-16 md:pt-0'} ${
            hideLeftNav ? '' : 'md:pl-16'
          }`}
        >
          {children}
        </main>
        {showFooter && <Footer />}
      </div>
    </div>
  );
};

export default Layout;
